import React from 'react';
import PropTypes from 'prop-types';
import CompareTagsModal from 'home/Machines/CompareTags/components/CompareTagsModal';
import NoteForm from '../organisms/NoteForm';
import AddChartModal from '../organisms/AddChartModal';
import AddTagModal from '../organisms/AddTagModal';
import EnvelopeAlarmModal from '../organisms/EnvelopeAlarm/EnvelopeAlarmModal';
import OverallAlarmModal from '../organisms/OverallAlarm/OverallAlarmModal';
import FeatureTrendModal from '../organisms/FeatureTrendModal';
import FeatureModal from '../organisms/FeatureModal';
import DemodSpectrumSettingsModal from '../organisms/DemodSpectrumSettingsModal';

const ChartsViewModals = (props) => {
  const {
    addingNote,
    amp_type,
    brushSelected,
    chartType,
    config,
    feature,
    machineId,
    waveAndSpecSelection,
    onCancelNote,
    tag,
    showWidth,
    editTrend,
    closeEditTrend,
    getChartData,
    refreshConfigMetadata,
    selectedTags,
    days,
    editTagInfo,
    envelopeAlarm,
    closeEnvelopeAlarm,
    measurement_type,
    componentNode,
    openOverallAlarm,
    toggleOverallAlarm,
    bin_nos,
    openFeatureDetails,
    closeFeatureDetailsClick,
    featureForDetails,
    openFeature,
    closeAddEditFeature,
    featureToOpen,
    editDemod,
    closeEditDemod,
    frequencyUnits
  } = props;

  return (
    <>
      {addingNote && (
        <NoteForm
          amp_type={amp_type}
          brushSelected={brushSelected}
          chart_type={chartType}
          config={config}
          data_source="tag"
          feature={feature}
          machine_id={machineId}
          measurement_id={waveAndSpecSelection ? waveAndSpecSelection.measurement_id : null}
          onCancel={onCancelNote}
          tag_id={tag && tag.id}
          showWidth={showWidth}
        />
      )}
      {editTrend && (
        <>
          {config && config.machines.length > 1 && (
            <CompareTagsModal
              close={closeEditTrend}
              isEditMode={!!config}
              config={config}
            />
          )}
          {config && config.machines.length === 1 && (
            <AddChartModal
              config={config}
              close={closeEditTrend}
              defaultChart={config.default}
              globalDays={days}
              trends_config={config.trends_config}
              getChartData={getChartData}
              showWidth={showWidth}
              refreshConfigMetadata={refreshConfigMetadata}
              selectedTags={selectedTags}
            />
          )}
        </>
      )}
      {editTagInfo && config.default && (
        <AddTagModal
          config={config}
          close={closeEditTrend}
          defaultChart={config.default}
          getChartData={getChartData}
          showWidth={showWidth}
          tag={tag}
          editTagInfo
        />
      )}
      {envelopeAlarm && (
        <EnvelopeAlarmModal
          config={config}
          tag={tag}
          feature={feature}
          amp_type={amp_type}
          close={closeEnvelopeAlarm}
          showWidth={showWidth}
          measurement_type={measurement_type}
          componentNode={componentNode}
          waveAndSpecSelection={waveAndSpecSelection}
          filterTrendChart={getChartData}
        />
      )}
      {openOverallAlarm && (
        <OverallAlarmModal
          config={config}
          tag={tag}
          feature={feature}
          ampType={amp_type}
          close={toggleOverallAlarm}
          showWidth={showWidth}
          bin_nos={bin_nos}
        />
      )}
      {openFeatureDetails &&
        config.spectrumFeatures &&
        config.spectrum && (
          <FeatureTrendModal
            spectrum={tag.spectrum}
            close={closeFeatureDetailsClick}
            tag={tag}
            ampType={amp_type}
            feature={featureForDetails}
            showWidth={showWidth}
          />
      )}

      {openFeature &&
        config.spectrumFeatures &&
        config.spectrum && (
          <FeatureModal
            close={closeAddEditFeature}
            spectrum={config.spectrum}
            tag={tag}
            features={config.spectrumFeatures}
            selectedFeature={featureToOpen}
            config={config}
            showWidth={showWidth}
          />
      )}
      {editDemod && (
        <DemodSpectrumSettingsModal
          close={closeEditDemod}
          tags={[tag]}
          showWidth={showWidth}
          freq_units={frequencyUnits}
        />
      )}
    </>
  );
};

/* eslint-disable react/require-default-props */
ChartsViewModals.propTypes = {
  addingNote: PropTypes.bool,
  amp_type: PropTypes.string,
  brushSelected: PropTypes.object,
  chartType: PropTypes.string,
  config: PropTypes.object,
  feature: PropTypes.string,
  machineId: PropTypes.string,
  waveAndSpecSelection: PropTypes.object,
  onCancelNote: PropTypes.func,
  tag: PropTypes.object,
  showWidth: PropTypes.bool,
  editTrend: PropTypes.bool,
  closeEditTrend: PropTypes.func,
  getChartData: PropTypes.func,
  refreshConfigMetadata: PropTypes.func,
  selectedTags: PropTypes.array,
  days: PropTypes.number,
  editTagInfo: PropTypes.bool,
  envelopeAlarm: PropTypes.bool,
  closeEnvelopeAlarm: PropTypes.func,
  measurement_type: PropTypes.number,
  componentNode: PropTypes.object,
  openOverallAlarm: PropTypes.bool,
  toggleOverallAlarm: PropTypes.func,
  bin_nos: PropTypes.array,
  openFeatureDetails: PropTypes.bool,
  closeFeatureDetailsClick: PropTypes.func,
  featureForDetails: PropTypes.object,
  openFeature: PropTypes.bool,
  closeAddEditFeature: PropTypes.func,
  featureToOpen: PropTypes.any,
  editDemod: PropTypes.bool,
  closeEditDemod: PropTypes.func,
  frequencyUnits: PropTypes.string
};

export default ChartsViewModals;
